export const env = {
  lang: 'ca'
};
